export const initWarehouseRoutes = (
    config: any,
    enabled: boolean = true,
) =>
    !enabled
        ? []
        : [
            {
                path: "/manage/warehouses",
                name: "warehouse",
                component: () => import("@/pages/manage/warehouses/index.vue"),
                meta: {
                    requiresAuth: true,
                    roles: [
                        config.roles.administrators,
                        config.roles.siteEditors,
                    ],
                },
            },
            {
                path: "/manage/warehouses/:id",
                name: "warehouse-id",
                component: () => import("@/pages/manage/warehouses/id.vue"),
                meta: {
                    requiresAuth: true,
                    roles: [
                        config.roles.administrators,
                        config.roles.siteEditors,
                    ],
                },
            },
        ];
